import { NotificationProps, showNotification } from "@mantine/notifications";
import Tick from "@common/components/icons/Tick";

// modals take ~400ms to close; the toast waits so the two never overlap
export function showSuccessNotification({
  delay = 400,
  ...props
}: NotificationProps & { delay?: number }): void {
  setTimeout(() => {
    showNotification({
      color: "green.2",
      icon: <Tick color="white" />,
      autoClose: 5000,
      ...props,
    });
  }, delay);
}
